@if (node$ | async; as node) {
  <app-custom-navigation-ui
    [node]="node"
    [flyout]="false"
    [ngClass]="(styleClass$ | async) ?? ''"
  ></app-custom-navigation-ui>
}
